export const CONTEXT_FILTER_SEPARATOR = "::";

export function encodeContextFilter(contextFilter) {
  return (contextFilter ?? []).flatMap((entry) =>
    (entry.values ?? []).map(
      (value) => `${entry.characteristic}${CONTEXT_FILTER_SEPARATOR}${value}`
    )
  );
}

export function decodeContextFilter(encoded) {
  const byCharacteristic = {};
  for (const item of encoded ?? []) {
    const separatorIndex = item.indexOf(CONTEXT_FILTER_SEPARATOR);
    if (separatorIndex <= 0) continue;
    const characteristic = item.slice(0, separatorIndex);
    const value = item.slice(separatorIndex + CONTEXT_FILTER_SEPARATOR.length);
    if (!value) continue;
    if (!byCharacteristic[characteristic]) byCharacteristic[characteristic] = [];
    byCharacteristic[characteristic].push(value);
  }
  return Object.entries(byCharacteristic).map(([characteristic, values]) => ({
    characteristic,
    values,
  }));
}

export function buildContextFilterOptions(characteristics, selectedEncoded) {
  const groups = (characteristics ?? [])
    .filter((characteristic) => (characteristic.options ?? []).length > 0)
    .map((characteristic) => ({
      label: characteristic.name,
      options: characteristic.options.map((option) => ({
        id: `${characteristic.name}${CONTEXT_FILTER_SEPARATOR}${option.value}`,
        value: `${characteristic.name}${CONTEXT_FILTER_SEPARATOR}${option.value}`,
        label: `${characteristic.name}: ${option.label || option.value}`,
      })),
    }));

  const known = new Set(groups.flatMap((group) => group.options.map((option) => option.value)));
  const stale = (selectedEncoded ?? []).filter((item) => !known.has(item));
  if (stale.length > 0) {
    groups.push({
      label: "No longer defined",
      options: stale.map((item) => ({
        id: item,
        value: item,
        label: item.replace(CONTEXT_FILTER_SEPARATOR, ": "),
      })),
    });
  }
  return groups;
}
